module.exports = __webpack_public_path__ + "img/1453598700.0abc65fe.jpg";